import ApiServices from '../services/api.service';
import CryptoJS from "crypto-js";

const CryptoJSAesJson = {
    stringify: function (cipherParams) {
        var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
        if (cipherParams.iv) j.iv = cipherParams.iv.toString();
        if (cipherParams.salt) j.s = cipherParams.salt.toString();
        return JSON.stringify(j);
    },
    parse: function (jsonStr) {
        var j = JSON.parse(jsonStr);
        var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams;
    }
}

const HashMake = {
    encrypt(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), process.env.VUE_APP_ENCRYPTKEY).toString();
    },
    decrypt(data) {
        try{
            return JSON.parse(
                CryptoJS.AES.decrypt(
                    data,
                    process.env.VUE_APP_ENCRYPTKEY
                ).toString(CryptoJS.enc.Utf8)
            );
        }catch(err){
            try{
                return JSON.parse(data)
            }catch(parseError){
                return data
            }
        }
    }
}

export default HashMake;
